import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { BelongExplainerVideo } from '../BelongExplainerVideo/BelongExplainerVideo.js';
import { Image } from '../Image/Image.js';
import css from './VideoSideContents.module.css.js';

const frameClassName = 'min-w-1/2 lg:min-w-[500px]';
const imgContainerClassName = 'aspect-w-12 aspect-h-10 hidden lg:block';
function VideoSideContents({
  autoplay
}) {
  return jsxs("div", {
    className: clsx(css.main, 'flex flex-1 items-center justify-center overflow-hidden pb-xl'),
    children: [jsx("div", {
      className: frameClassName,
      children: jsx("div", {
        className: imgContainerClassName,
        children: jsx(Image, {
          src: "/belong-explainer-video/lp_video_frames_left.png",
          alt: ""
        })
      })
    }), jsx(BelongExplainerVideo, {
      autoplay: autoplay,
      wrapperClassName: clsx(css.video_container, 'mx-2sm max-w-container-md md:mx-xl lg:mx-0 lg:min-w-container-md')
    }), jsx("div", {
      className: frameClassName,
      children: jsx("div", {
        className: imgContainerClassName,
        children: jsx(Image, {
          src: "/belong-explainer-video/lp_video_frames_right.png",
          alt: ""
        })
      })
    })]
  });
}

export { VideoSideContents };
